import { IState } from 'legacy/lut/store'

export const selectWidgets = (state: IState) => state.widgets
